import { KeyboardArrowDown } from "@mui/icons-material";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { Box, IconButton, TableCell, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GroupedTableSearchProps } from "./useGroupedTableSearch";

type Props = {
  search?: GroupedTableSearchProps;
  setOpen: () => void;
  open: boolean;
};

export const TableGroupSearchToggle = ({ search, setOpen, open }: Props) => {
  const { t } = useTranslation();

  if (!search) return null;

  return (
    <TableCell>
      <Box
        display="flex"
        alignItems="center"
        gap="18px"
        position="absolute"
        bottom="5px"
        left="0px"
      >
        <IconButton
          size="small"
          onClick={setOpen}
          sx={{ padding: 0, margin: 0, marginLeft: 1, color: "#4A1D9C" }}
        >
          {open ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
        <Typography
          whiteSpace="nowrap"
          color="#4A1D9C"
          fontWeight="700"
          variant="header"
          textTransform="uppercase"
          fontSize="14px"
        >
          {t("common:searchTitle")}
        </Typography>
      </Box>
    </TableCell>
  );
};
